import { SignupForm } from "./authTypes";

export const createValidationMessages = (value: string): string[] => {
  const result = [];
  if (value.length < 8)
    result.push("Your password must be at least 8 characters.");
  if (value.length > 64)
    result.push("Your password must be fewer than 65 characters.");
  return result;
};

export const getPasswordStrength = (score: number) => {
  switch (score) {
    case 0:
      return "Very Weak";
    case 1:
      return "Weak";
    case 2:
      return "OK";
    case 3:
      return "Good";
    case 4:
      return "Strong";
  }
};

export const validateSignupForm = (form: SignupForm): boolean => {
  if (!form.name) return false;
  if (!form.phone) return false;
  if (!form.email) return false;
  if (!form.company) return false;
  if (!form.password) return false;
  return true;
};
